import { dbPromise } from "./db";

/**
 * Generic IndexedDB CRUD helpers.
 * Each function expects a valid object store name defined in `db.js`.
 */

export async function createRecord(storeName, record) {
  try {
    const db = await dbPromise;
    if (!db.objectStoreNames.contains(storeName)) {
      console.warn(`Store not found: ${storeName}`);
      return null;
    }
    const toStore = { ...record };
    if (typeof toStore.id === "undefined" || toStore.id === null) {
      toStore.id = `${storeName}-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2, 8)}`;
    }
    return await db.add(storeName, toStore);
  } catch (e) {
    console.warn("createRecord failed", e);
    return null;
  }
}

export async function updateRecord(storeName, record) {
  try {
    const db = await dbPromise;
    if (!db.objectStoreNames.contains(storeName)) {
      console.warn(`Store not found: ${storeName}`);
      return null;
    }
    if (typeof record.id === "undefined" || record.id === null) {
      console.warn("updateRecord requires an `id` property on the record");
      return null;
    }
    return await db.put(storeName, record);
  } catch (e) {
    console.warn("updateRecord failed", e);
    return null;
  }
}

export async function getRecord(storeName, key) {
  try {
    const db = await dbPromise;
    if (!db.objectStoreNames.contains(storeName)) {
      console.warn(`Store not found: ${storeName}`);
      return null;
    }
    return await db.get(storeName, key);
  } catch (e) {
    console.warn("getRecord failed", e);
    return null;
  }
}

export async function getAllRecords(storeName) {
  try {
    const db = await dbPromise;
    if (!db.objectStoreNames.contains(storeName)) {
      console.warn(`Store not found: ${storeName}`);
      return [];
    }
    return await db.getAll(storeName);
  } catch (e) {
    console.warn("getAllRecords failed", e);
    return [];
  }
}

export async function deleteRecord(storeName, key) {
  try {
    const db = await dbPromise;
    if (!db.objectStoreNames.contains(storeName)) {
      console.warn(`Store not found: ${storeName}`);
      return null;
    }
    return await db.delete(storeName, key);
  } catch (e) {
    console.warn("deleteRecord failed", e);
    return null;
  }
}

export async function clearStore(storeName) {
  try {
    const db = await dbPromise;
    if (!db.objectStoreNames.contains(storeName)) {
      console.warn(`Store not found: ${storeName}`);
      return null;
    }
    return await db.clear(storeName);
  } catch (e) {
    console.warn("clearStore failed", e);
    return null;
  }
}

export default {
  createRecord,
  updateRecord,
  getRecord,
  getAllRecords,
  deleteRecord,
  clearStore,
};
